export const RESET_STORE_ACTION_TYPE = "RESET";
export const LOCAL_STORAGE_NETWORK = "stellarLab:network";
